import React, {useContext, useEffect} from 'react';
import {useHistory} from "react-router-dom";
import {userGetByEmail} from "../requests/User";
import {Auth} from "aws-amplify";
import {AppContext} from "../libs/ContextLibs";

export default function Home(props) {
    const {isUserNameOverride, userNameOverride} = useContext(AppContext);
    const history = useHistory();

    useEffect(() => {
        const onLoad = async () => {
            let user = await Auth.currentUserInfo();
            userGetByEmail((isUserNameOverride && userNameOverride) ? userNameOverride : user.username, (response) => {
                if (response.data && response.data.default_chart !== null && response.data.default_chart.length > 0) {
                    history.push('/dashboard/' + response.data.default_chart);
                }
            });
        };
        onLoad();
    }, [history]);

    return (

        <>
        </>
    );
}
